import { Separator } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { ModuleSeparatorStyles } from './ModuleSeparator.styles';

type Props = {
	className?: string;
	orientation?: 'horizontal' | 'vertical';
};

export function ModuleSeparator({ className, orientation = 'horizontal' }: Props) {
	const styles = ModuleSeparatorStyles({ orientation });
	return <Separator data-testid="inner-separator" className={cn(styles, className)} orientation={orientation} />;
}
